(() => {
  const config = window.SkaiciusConfig || {};
  const apiUrl = String(config.apiUrl || '').replace(/\/$/, '');
  const dialog = document.querySelector('[data-login-dialog]');
  const emailForm = document.querySelector('[data-email-form]');
  const codeForm = document.querySelector('[data-code-form]');
  const status = document.querySelector('[data-member-status]');
  const accessBox = document.querySelector('[data-member-access]');
  const dashboard = document.querySelector('[data-member-dashboard]');
  const reviewList = document.querySelector('[data-review-list]');
  const emailInput = document.querySelector('#member-email');
  const codeInput = document.querySelector('#member-code');
  const tokenKey = 'skaicius-session-token';
  if(!apiUrl){if(emailForm)emailForm.hidden=true;if(status)status.textContent='Prisijungimas bus įjungtas, kai bus paruošta mokymosi paslauga.';}

  let signedEmail = sessionStorage.getItem('skaicius-session-email') || '';

  async function api(path, body) {
    if (!apiUrl) throw new Error('Prisijungimo paslauga dar nesujungta.');
    const token = sessionStorage.getItem(tokenKey);
    const response = await fetch(`${apiUrl}${path}`, {
      method: body ? 'POST' : 'GET',
      headers: { 'content-type': 'application/json', ...(token ? { authorization: `Bearer ${token}` } : {}) },
      ...(body ? { body: JSON.stringify(body) } : {})
    });
    const result = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(result.error || 'Užklausa nepavyko. Pabandyk dar kartą.');
    return result;
  }
  async function refreshAccess() {
    if (!sessionStorage.getItem(tokenKey)) { if(dashboard)dashboard.hidden=true; return false; }
    try {
      const [result, history] = await Promise.all([api('/api/access'), api('/api/progress')]);
      const rows=history.progress||[],solvedRows=rows.filter(item=>item.solved),reviewRows=rows.filter(item=>!item.solved).slice(0,3);
      const solvedCount = solvedRows.length;
      accessBox.hidden = false;
      accessBox.textContent = result.active
        ? `Aktyvus ${result.planDays} dienų planas · galioja iki ${new Date(result.endsAt).toLocaleDateString('lt-LT')}. Išspręsta užduočių: ${solvedCount}.`
        : `Prisijungta kaip ${signedEmail}. Išspręsta užduočių: ${solvedCount}. Mokamas planas šiai paskyrai nerastas.`;
      window.SkaiciusMember.activePlan=Boolean(result.active);
      if(dashboard)dashboard.hidden=!result.active;
      if(result.active){
        const planStatus=document.querySelector('[data-plan-status]');if(planStatus)planStatus.textContent=`${result.planDays} dienų planas · aktyvus iki ${new Date(result.endsAt).toLocaleDateString('lt-LT')}. Tavo tikslas — suprasti po vieną žingsnį.`;
        const solvedNode=document.querySelector('[data-progress-solved]'),reviewNode=document.querySelector('[data-progress-review]'),streakNode=document.querySelector('[data-progress-streak]');
        if(solvedNode)solvedNode.textContent=String(solvedCount);
        const weekRows=rows.filter(item=>item.updated_at>Date.now()-7*86400000),weekSolved=weekRows.filter(item=>item.solved).length,weekSummary=document.querySelector('[data-weekly-summary]');
        if(weekSummary)weekSummary.textContent=`Šią savaitę išsprendei ${weekSolved} uždavinių. ${weekRows.filter(item=>!item.solved).length?`Dar ${weekRows.filter(item=>!item.solved).length} uždaviniai laukia pakartojimo.`:'Tęsk savo tempu — svarbiausia suprasti sprendimo žingsnius.'}`;
        const dailyFocus=document.querySelector('[data-daily-focus]');
        if(dailyFocus)dailyFocus.textContent=reviewRows.length?`Pirmiausia verta grįžti prie ${reviewRows[0].grade} klasės uždavinio, kuriame prireikė dar vieno bandymo.`:'Kol kas kartojimo eilė tuščia. Pasirink dabartinę temą ir spręsk 3 uždavinius.';if(reviewNode)reviewNode.textContent=String(rows.filter(item=>!item.solved).length);
        const days=new Set(rows.map(item=>new Date(item.updated_at).toISOString().slice(0,10)));let streak=0,day=new Date();if(!days.has(day.toISOString().slice(0,10)))day.setUTCDate(day.getUTCDate()-1);while(days.has(day.toISOString().slice(0,10))&&streak<365){streak++;day.setUTCDate(day.getUTCDate()-1)}if(streakNode)streakNode.textContent=String(streak);
        if(reviewList){reviewList.replaceChildren();if(!reviewRows.length){const empty=document.createElement('p');empty.className='member-empty';empty.textContent='Puiku — kartojimo eilė tuščia. Toliau spręsk naują temą.';reviewList.append(empty)}else reviewRows.forEach(row=>{const card=document.createElement('article');card.className='review-item';const title=document.createElement('b');title.textContent=`${row.grade} klasė${row.course?` · ${row.course} kursas`:''}`;const question=document.createElement('p');question.textContent=row.question_text||'Uždavinys';const work=document.createElement('small');work.textContent=`Tavo sprendimas: ${row.student_work||'dar neužrašytas'}`;const button=document.createElement('button');button.type='button';button.className='hint-button';button.textContent='Spręsti panašų';button.addEventListener('click',()=>{const grade=document.querySelector('#grade-select'),course=document.querySelector('#course-select');if(grade){grade.value=String(row.grade);grade.dispatchEvent(new Event('change',{bubbles:true}))}if(row.course&&course){course.value=row.course;course.dispatchEvent(new Event('change',{bubbles:true}))}document.querySelector('#praktika')?.scrollIntoView({behavior:'smooth'})});card.append(title,question,work,button);reviewList.append(card)})}
      }
      window.dispatchEvent(new CustomEvent('skaicius:access',{detail:{active:Boolean(result.active)}}));
      return Boolean(result.active);
    } catch (error) {
      window.SkaiciusMember.activePlan=false;if(dashboard)dashboard.hidden=true;window.dispatchEvent(new CustomEvent('skaicius:access',{detail:{active:false}}));
      accessBox.hidden = false;
      accessBox.textContent = error.message;
      return false;
    }
  }
  document.querySelectorAll('[data-open-login]').forEach(button => button.addEventListener('click', () => {
    if (dialog && !dialog.open) dialog.showModal();
    if (signedEmail) emailInput.value = signedEmail;
    refreshAccess();
  }));
  document.querySelector('[data-close-login]')?.addEventListener('click', () => dialog?.close());
  dialog?.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  emailForm?.addEventListener('submit', async event => {
    event.preventDefault(); status.textContent = 'Siunčiame kodą…';
    try {
      signedEmail = emailInput.value.trim().toLowerCase();
      await api('/api/auth/send-code', { email: signedEmail });
      sessionStorage.setItem('skaicius-session-email', signedEmail);
      codeForm.hidden = false; codeInput.focus();
      status.textContent = 'Kodas išsiųstas. Patikrink el. paštą ir šlamšto aplanką.';
    } catch (error) { status.textContent = error.message; }
  });
  codeForm?.addEventListener('submit', async event => {
    event.preventDefault(); status.textContent = 'Tikriname kodą…';
    try {
      const result = await api('/api/auth/verify', { email: signedEmail, code: codeInput.value.trim() });
      sessionStorage.setItem(tokenKey, result.token);
      sessionStorage.setItem('skaicius-session-email', result.email);
      signedEmail = result.email; status.textContent = `Prisijungei kaip ${signedEmail}.`;
      codeForm.hidden = true; await refreshAccess();
    } catch (error) { status.textContent = error.message; }
  });
  window.SkaiciusMember = {
    api,
    activePlan:false,
    token: () => sessionStorage.getItem(tokenKey),
    email: () => signedEmail,
    async hasActivePlan() {
      if (!sessionStorage.getItem(tokenKey)) return false;
      if(window.SkaiciusMember.activePlan)return true;
      return await refreshAccess();
    }
  };
  if(sessionStorage.getItem(tokenKey))refreshAccess();
})();
